/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ArrowUpIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "arrow-up", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7 11.5L12.5 6L18 11.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 6V18.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ArrowUpIcon);
export default ForwardRef;
//# sourceMappingURL=arrowUpIcon.js.map